import {
    ADD_TO_CART_FAIL,
    ADD_TO_CART_REQUEST,
    ADD_TO_CART_SUCCESS,
    DELETE_ITEM_REQUES,
    CLEAR_ERRORS
} from "../constants/cartConstant"

const initialState = {
    cartItems: localStorage.getItem("cartItems") ? JSON.parse(localStorage.getItem("cartItems")) : []
}

export const cartReducer = (state = initialState, action) => {

    switch (action.type) {
        case ADD_TO_CART_REQUEST:
            
            const item = action.payload

            const isItemExists = state.cartItems.find((i)=>i._id === item._id)

            if (isItemExists) {
                return {
                    ...state,
                    cartItems: state.cartItems.map((i)=>
                        i._id === isItemExists._id ? item : i
                    )
                }
            } else {
                return {
                    ...state,
                    cartItems: [...state.cartItems, item]
                }
            }
        
        case DELETE_ITEM_REQUES:

            return {
                ...state,
                cartItems: state.cartItems.filter((i)=>i._id !== action.payload)
            }

        case CLEAR_ERRORS:
    
            return {
                ...state,
                error: null
            }
    
        default:
            return state
    }

}
